import { render, staticRenderFns } from "./BillAPChangeList.vue?vue&type=template&id=f2efeed6"
import script from "./BillAPChangeList.vue?vue&type=script&lang=js"
export * from "./BillAPChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports